export default "__VITE_PUBLIC_ASSET__471ab74d__"